export const INVALID_FOLDER_NAME_MESSAGE = "Bitte einen gültigen Ordnernamen eingeben (ohne Schrägstriche).";

export const COPY_LINK_SUCCESS_MESSAGE = "Download-Link kopiert";

export const UPLOAD_SUCCESS_MESSAGE = "Datei hochgeladen";

export const FOLDER_CREATED_MESSAGE = "Ordner erstellt";

export const UPLOAD_FAILED_MESSAGE = "Upload fehlgeschlagen.";

export const FOLDER_CREATE_FAILED_MESSAGE = "Ordner konnte nicht erstellt werden.";

export const COPY_LINK_FAILED_MESSAGE = "Link konnte nicht kopiert werden.";

export const DELETE_FILE_SUCCESS_MESSAGE = "Datei gelöscht";

export const DELETE_FOLDER_SUCCESS_MESSAGE = "Ordner gelöscht";

export const DELETE_FAILED_MESSAGE = "Löschen fehlgeschlagen.";

export const EXPLORER_PATH_SEARCH_PARAM = "path";

export const WEB_DOWNLOADS_INFO_COLLAPSED_STORAGE_KEY = "cms.webDownloads.infoCollapsed";

export interface CmsCollectionDownloadHint {
  collectionName: string;
  uploadLocation: string;
}

/** Downloads tied to a CMS document — upload in the collection, not in `web/downloads/`. */
export const CMS_COLLECTION_DOWNLOAD_HINTS: CmsCollectionDownloadHint[] = [
  { collectionName: "Blogartikel", uploadLocation: "Feld „Download Link“ am Blogartikel" },
  { collectionName: "Podcast Folgen", uploadLocation: "Feld „Download Link“ an der Folge" },
  { collectionName: "Audio Kurse", uploadLocation: "Audio- und Hausaufgaben-Dateien je Lektion" },
  { collectionName: "Intro Kurse", uploadLocation: "Audio-Dateien je Lektion" },
  { collectionName: "Tagesmeditationen", uploadLocation: "Meditations-Audio am Eintrag" },
];
